<app-ksuite-info-block *ngIf="currentTunnel === TUNNELS.KSUITE"></app-ksuite-info-block>
<app-signup-rightblock-classic *ngIf="currentTunnel === TUNNELS.CLASSIC"></app-signup-rightblock-classic>
